// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Share from '../_raw/ui/icon_share.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Share);
